/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthSupportUids } from '../../models/auth-support-uids';

export interface VehicleRemoveAuthSupportVnf$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The object ID. Must be a valid ID.
 */
  vehicleUid: string;
      body: AuthSupportUids
}

export function vehicleRemoveAuthSupportVnf(http: HttpClient, rootUrl: string, params: VehicleRemoveAuthSupportVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, vehicleRemoveAuthSupportVnf.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('vehicleUid', params.vehicleUid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

vehicleRemoveAuthSupportVnf.PATH = '/custom/subscriptions/{uid}/vehicles/{vehicleUid}/auth-supports/remove';
